export var GAutocompleteTypes;
(function (GAutocompleteTypes) {
  GAutocompleteTypes["GEOCODE"] = "geocode";
  GAutocompleteTypes["ADDRESS"] = "address";
  GAutocompleteTypes["DRAWONMAP"] = "locality|route";
  // eslint-disable-next-line max-len
  GAutocompleteTypes["PLACE_DETAILS_FIELDS"] = "address_components,adr_address,formatted_address,geometry,icon,icon_background_color,icon_mask_base_uri,name,place_id,plus_code,type,url,utc_offset,vicinity";
})(GAutocompleteTypes || (GAutocompleteTypes = {}));